export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";